import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { staticFilesApi, StaticFile } from "../staticFilesApi";

export const useStaticFiles = () => {
  const queryClient = useQueryClient();

  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.STATIC_FILES(),
    queryFn: () => staticFilesApi.getAll(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.STATIC_FILES() });
  };

  return {
    isLoading,
    files: data ?? [],
    invalidate,
  };
};

export const useUploadStaticFile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ file, publicPath }: { file: File; publicPath?: string }) =>
      staticFilesApi.upload(file, publicPath),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.STATIC_FILES() });
    },
  });
};

export const useDeleteStaticFile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => staticFilesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.STATIC_FILES() });
    },
  });
};
